// extracted by mini-css-extract-plugin
module.exports = {"numbers":"Timer_numbers__1Z8lN","countdown":"Timer_countdown__3WsiC","svg":"Timer_svg__24c7R","circle":"Timer_circle__192zV"};